@for (item of allPosiibleAnswers; track item) {
  <div class="item" fxLayout="row" fxLayoutAlign="start center">
    <p class="percentage">{{ item.percentage }}% ({{ item.value }})</p>
    <mat-progress-bar [value]="item.percentage"></mat-progress-bar>
    <p class="value">{{ item.name }}</p>
  </div>
}
